module.exports = __webpack_public_path__ + "img/thumb-ken-off.1e39e095.jpg";